export enum AnalyticsEvents {
  DEVICE_CREATED_OR_UPDATED = "Device Created or Updated",
  DEVICE_TOKEN_REGISTERED = "Device Token Registered",
  DEVICE_DELETED = "Device Deleted",
  PUSH_NOTIFICATION_PERMISSIONS_DENIED = "Push Notification Permissions Denied",
  PUSH_NOTIFICATION_CLICKED = "Push Notification Clicked",
  PUSH_NOTIFICATION_RECEIVED = "Push Notification Received",
  PUSH_NOTIFICATION_REGISTRATION_FAILED = "Push Notification Registration Failed",
  ADONIS_VIEWED = "AdonisViewed",
  ADONIS_LINK_CLICKED = "AdonisLinkClicked",
  GIFTCARD_SHARE_CLICKED = "GiftCardShareClicked",
  PDP_SHARE_CLICKED = "PdpShareClicked",
  GIFT_CARD_SHOP_CARD_CTA_CLICKED = "GiftCardShopCardCTAClicked",
  PRODUCTS_SHOP_CARD_CTA_CLICKED = "ProductsShopCardCTAClicked",
  ANONYMOUS_CHECKOUT_VERIFIED = "AnonymousCheckoutVerified",
  ANONYMOUS_CART_RECONCILED = "AnonymousCartReconciled",
}
